module Client.Forms.PhysicalSensor

open Client.Components
open Client.Components.Select
open Client.DomainTypes.Msg
open Client.DomainTypes.PhysicalSensorList
open Client.InfrastructureTypes
open Fulma
open Microsoft.FSharp.Core
open Shared.Dto.User
open Shared.DtoTypes.DeviceLocation
open Shared.DtoTypes.PhysicalSensor
open Shared.Infrastructure
open Fable.React
open Fable.React.Props


let private sensorModelToOption (sensorModel: SensorModel) : PhysicalSensorModelOption =
    match sensorModel with
    | SensorModel.LHT65 -> PhysicalSensorModelOption.LHT65
    | SensorModel.LSN50v2_S31 -> PhysicalSensorModelOption.LSN50v2_S31
    | SensorModel.S31_LS -> PhysicalSensorModelOption.S31_LS
    | SensorModel.S31_LB -> PhysicalSensorModelOption.S31_LB
    | SensorModel.LSE01 -> PhysicalSensorModelOption.LSE01
    | SensorModel.SE01_LS -> PhysicalSensorModelOption.SE01_LS
    | SensorModel.SE01_LB -> PhysicalSensorModelOption.SE01_LB
    | SensorModel.LSN50v2_Rain_01mm -> PhysicalSensorModelOption.LSN50v2_Rain_01mm
    | SensorModel.LSN50v2_Rain_02mm -> PhysicalSensorModelOption.LSN50v2_Rain_02mm
    | SensorModel.LSN50v2_Wind -> PhysicalSensorModelOption.LSN50v2_Wind
    | SensorModel.SN50v3_LS_Rain_01mm -> PhysicalSensorModelOption.SN50v3_LS_Rain_01mm
    | SensorModel.SN50v3_LB_Rain_01mm -> PhysicalSensorModelOption.SN50v3_LB_Rain_01mm
    | SensorModel.SN50v3_LS_Rain_02mm -> PhysicalSensorModelOption.SN50v3_LS_Rain_02mm
    | SensorModel.SN50v3_LB_Rain_02mm -> PhysicalSensorModelOption.SN50v3_LB_Rain_02mm
    | SensorModel.SN50v3_LS_Wind -> PhysicalSensorModelOption.SN50v3_LS_Wind
    | SensorModel.SN50v3_LB_Wind -> PhysicalSensorModelOption.SN50v3_LB_Wind
    | SensorModel.LLMS01 -> PhysicalSensorModelOption.LLMS01
    | SensorModel.LSPH01 -> PhysicalSensorModelOption.LSPH01
    | SensorModel.WSC1L -> PhysicalSensorModelOption.WSC1L
    | SensorModel.DDS20_LB -> PhysicalSensorModelOption.DDS20_LB
    | SensorModel.DDS20_LS -> PhysicalSensorModelOption.DDS20_LS
    | SensorModel.RS485_LB_ZFS_02 -> PhysicalSensorModelOption.RS485_LB_ZFS_02
    | SensorModel.RS485_LS_ZFS_02 -> PhysicalSensorModelOption.RS485_LS_ZFS_02
    | SensorModel.SE0X_LB -> PhysicalSensorModelOption.SE0X_LB
    | SensorModel.PS_LB _ -> PhysicalSensorModelOption.PS_LB
    | SensorModel.PS_LS _ -> PhysicalSensorModelOption.PS_LS
    | SensorModel.SPH01_LB -> PhysicalSensorModelOption.SPH01_LB
    | SensorModel.SPH01_LS -> PhysicalSensorModelOption.SPH01_LS
    | SensorModel.LDDS75 -> PhysicalSensorModelOption.LDDS75
    | SensorModel.DDS75_LB -> PhysicalSensorModelOption.DDS75_LB
    | SensorModel.DDS75_LS -> PhysicalSensorModelOption.DDS75_LS
    | SensorModel.WQS_LB -> PhysicalSensorModelOption.WQS_LB
    | SensorModel.WQS_LS -> PhysicalSensorModelOption.WQS_LS

let private toSensorModel
    (pressureProbe: PressureProbeOption)
    (maybeDepth: int option)
    (option: PhysicalSensorModelOption)
    : SensorModel option =
    match option with
    | PhysicalSensorModelOption.LHT65 -> Some SensorModel.LHT65
    | PhysicalSensorModelOption.LSN50v2_S31 -> Some SensorModel.LSN50v2_S31
    | PhysicalSensorModelOption.S31_LS -> Some SensorModel.S31_LS
    | PhysicalSensorModelOption.S31_LB -> Some SensorModel.S31_LB
    | PhysicalSensorModelOption.LSE01 -> Some SensorModel.LSE01
    | PhysicalSensorModelOption.SE01_LS -> Some SensorModel.SE01_LS
    | PhysicalSensorModelOption.SE01_LB -> Some SensorModel.SE01_LB
    | PhysicalSensorModelOption.LSN50v2_Rain_01mm -> Some SensorModel.LSN50v2_Rain_01mm
    | PhysicalSensorModelOption.LSN50v2_Rain_02mm -> Some SensorModel.LSN50v2_Rain_02mm
    | PhysicalSensorModelOption.LSN50v2_Wind -> Some SensorModel.LSN50v2_Wind
    | PhysicalSensorModelOption.SN50v3_LS_Rain_01mm -> Some SensorModel.SN50v3_LS_Rain_01mm
    | PhysicalSensorModelOption.SN50v3_LB_Rain_01mm -> Some SensorModel.SN50v3_LB_Rain_01mm
    | PhysicalSensorModelOption.SN50v3_LS_Rain_02mm -> Some SensorModel.SN50v3_LS_Rain_02mm
    | PhysicalSensorModelOption.SN50v3_LB_Rain_02mm -> Some SensorModel.SN50v3_LB_Rain_02mm
    | PhysicalSensorModelOption.SN50v3_LS_Wind -> Some SensorModel.SN50v3_LS_Wind
    | PhysicalSensorModelOption.SN50v3_LB_Wind -> Some SensorModel.SN50v3_LB_Wind
    | PhysicalSensorModelOption.LLMS01 -> Some SensorModel.LLMS01
    | PhysicalSensorModelOption.LSPH01 -> Some SensorModel.LSPH01
    | PhysicalSensorModelOption.WSC1L -> Some SensorModel.WSC1L
    | PhysicalSensorModelOption.DDS20_LB -> Some SensorModel.DDS20_LB
    | PhysicalSensorModelOption.DDS20_LS -> Some SensorModel.DDS20_LS
    | PhysicalSensorModelOption.RS485_LB_ZFS_02 -> Some SensorModel.RS485_LB_ZFS_02
    | PhysicalSensorModelOption.RS485_LS_ZFS_02 -> Some SensorModel.RS485_LS_ZFS_02
    | PhysicalSensorModelOption.SE0X_LB -> Some SensorModel.SE0X_LB
    | PhysicalSensorModelOption.PS_LB ->
        match pressureProbe, maybeDepth with
        | PressureProbeOption.WaterDepth, Some depth ->
            PressureProbe.WaterDepth { Depth = depth } |> SensorModel.PS_LB |> Some
        | PressureProbeOption.WaterDepth, None -> None
        | PressureProbeOption.Pressure, _ -> PressureProbe.Pressure |> SensorModel.PS_LS |> Some
    | PhysicalSensorModelOption.PS_LS ->
        match pressureProbe, maybeDepth with
        | PressureProbeOption.WaterDepth, Some depth ->
            PressureProbe.WaterDepth { Depth = depth } |> SensorModel.PS_LS |> Some
        | PressureProbeOption.WaterDepth, None -> None
        | PressureProbeOption.Pressure, _ -> PressureProbe.Pressure |> SensorModel.PS_LS |> Some
    | PhysicalSensorModelOption.SPH01_LB -> Some SensorModel.SPH01_LB
    | PhysicalSensorModelOption.SPH01_LS -> Some SensorModel.SPH01_LS
    | PhysicalSensorModelOption.LDDS75 -> Some SensorModel.LDDS75
    | PhysicalSensorModelOption.DDS75_LB -> Some SensorModel.DDS75_LB
    | PhysicalSensorModelOption.DDS75_LS -> Some SensorModel.DDS75_LS
    | PhysicalSensorModelOption.WQS_LB -> Some SensorModel.WQS_LB
    | PhysicalSensorModelOption.WQS_LS -> Some SensorModel.WQS_LS

type Model = {
    EditExisting: bool
    AvailableUsers: UserDto list
    AvailableLocations: DeviceLocation list
    Id: int
    Name: string option
    AppEui: string option
    DeviceEui: string option
    AppKey: string option
    SelectedModel: PhysicalSensorModelOption
    TtsDescription: string option
    Note: string option
    DeviceCondition: DeviceCondition
    MaxHumidity: float option
    SelectedLocation: DeviceLocation
    SelectedUser: UserDto option
    RequestRunning: bool
    SelectedPressureProbe: PressureProbeOption
    LiquidProbeDepth: int option
}


type Msg =
    | NameUpdated
    | SelectedTypeUpdated

let init (locations: DeviceLocation list) (users: UserDto list) (maybeExistingSensor: PhysicalSensor option) =
    match maybeExistingSensor with
    | Some(Configured existing) ->
        let user =
            existing.BaseData.UserId
            |> Option.bind (fun userId -> List.tryFind (fun (u: UserDto) -> u.Id = userId) users)

        let location =
            existing.BaseData.LocationId
            |> Option.bind (fun locationId -> List.tryFind (fun (l: DeviceLocation) -> l.Id = locationId) locations)
            |> Option.defaultValue (List.head locations)

        let selectedModel, pressureProbe, depth =
            match existing.Configuration with
            | SensorModel.PS_LB(PressureProbe.WaterDepth meters) ->
                (PhysicalSensorModelOption.PS_LB, PressureProbeOption.WaterDepth, Some meters.Depth)
            | SensorModel.PS_LS(PressureProbe.WaterDepth meters) ->
                (PhysicalSensorModelOption.PS_LS, PressureProbeOption.WaterDepth, Some meters.Depth)
            | _ -> (existing.Configuration |> sensorModelToOption, PressureProbeOption.WaterDepth, None)

        {
            Id = existing.BaseData.Id
            AvailableUsers = users
            AvailableLocations = locations
            EditExisting = true
            Name = Some existing.BaseData.Name
            AppEui = Some existing.BaseData.AppEui
            DeviceEui = Some existing.BaseData.DeviceEui
            AppKey = Some existing.BaseData.AppKey
            SelectedModel = selectedModel
            TtsDescription = existing.BaseData.TtsDescription
            DeviceCondition = existing.BaseData.Condition
            MaxHumidity = existing.BaseData.MaxHumidity
            Note = existing.BaseData.Note
            SelectedLocation = location
            SelectedUser = user
            RequestRunning = false
            SelectedPressureProbe = pressureProbe
            LiquidProbeDepth = depth
        }
    | Some(UnConfigured existing) ->
        let user =
            existing.UserId
            |> Option.bind (fun userId -> List.tryFind (fun (u: UserDto) -> u.Id = userId) users)

        let location =
            existing.LocationId
            |> Option.bind (fun locationId -> List.tryFind (fun (l: DeviceLocation) -> l.Id = locationId) locations)
            |> Option.defaultValue (List.head locations)

        {
            Id = existing.Id
            AvailableUsers = users
            AvailableLocations = locations
            EditExisting = true
            Name = Some existing.Name
            AppEui = Some existing.AppEui
            DeviceEui = Some existing.DeviceEui
            AppKey = Some existing.AppKey
            SelectedModel = PhysicalSensorModelOption.LHT65
            TtsDescription = existing.TtsDescription
            DeviceCondition = existing.Condition
            MaxHumidity = existing.MaxHumidity
            Note = existing.Note
            SelectedLocation = location
            SelectedUser = user
            RequestRunning = false
            SelectedPressureProbe = PressureProbeOption.WaterDepth
            LiquidProbeDepth = None
        }
    | None -> {
        Id = 0
        AvailableUsers = users
        AvailableLocations = locations
        EditExisting = false
        Name = None
        AppEui = None
        DeviceEui = None
        AppKey = None
        SelectedModel = PhysicalSensorModelOption.LHT65
        TtsDescription = None
        DeviceCondition = DeviceCondition.Operational
        MaxHumidity = None
        Note = None
        SelectedLocation = List.head locations
        SelectedUser = None
        RequestRunning = false
        SelectedPressureProbe = PressureProbeOption.WaterDepth
        LiquidProbeDepth = None
      }

let private tryCreateSensor (model: Model) =
    let userId = Option.map (fun (user: UserDto) -> user.Id) model.SelectedUser

    let maybeSensorModel =
        toSensorModel model.SelectedPressureProbe model.LiquidProbeDepth model.SelectedModel

    let maybeBaseData =
        Some createPhysicalSensorBaseData
        |> Option.apply (Some model.Id)
        |> Option.apply (model.DeviceEui |> Option.map (fun eui -> sprintf "eui-%s" (eui.ToLower())))
        |> Option.apply model.Name
        |> Option.apply model.DeviceEui
        |> Option.apply model.AppEui
        |> Option.apply model.AppKey
        |> Option.apply (Some model.TtsDescription)
        |> Option.apply (Some userId)
        |> Option.apply (Some model.DeviceCondition)
        |> Option.apply (Some(Some model.SelectedLocation.Id))
        |> Option.apply (Some model.MaxHumidity)
        |> Option.apply (Some model.Note)

    match maybeBaseData, maybeSensorModel with
    | Some baseData, Some sensorModel ->
        {
            BaseData = baseData
            Configuration = sensorModel
        }
        |> Some
    | _, _ -> None


let modelToOption sensorModel =
    let sensorModelString = sensorModelOptionToString sensorModel

    option [ Value sensorModelString ] [ str sensorModelString ]

let sensorModelSelect (selected: PhysicalSensorModelOption) dispatch =
    let modelList = [
        PhysicalSensorModelOption.LHT65
        PhysicalSensorModelOption.LSN50v2_S31
        PhysicalSensorModelOption.S31_LS
        PhysicalSensorModelOption.S31_LB
        PhysicalSensorModelOption.LSE01
        PhysicalSensorModelOption.SE01_LS
        PhysicalSensorModelOption.SE01_LB
        PhysicalSensorModelOption.SE0X_LB
        PhysicalSensorModelOption.LSN50v2_Rain_01mm
        PhysicalSensorModelOption.LSN50v2_Rain_02mm
        PhysicalSensorModelOption.SN50v3_LS_Rain_01mm
        PhysicalSensorModelOption.SN50v3_LB_Rain_01mm
        PhysicalSensorModelOption.SN50v3_LS_Rain_02mm
        PhysicalSensorModelOption.SN50v3_LB_Rain_02mm
        PhysicalSensorModelOption.LLMS01
        PhysicalSensorModelOption.LSPH01
        PhysicalSensorModelOption.LSN50v2_Wind
        PhysicalSensorModelOption.SN50v3_LS_Wind
        PhysicalSensorModelOption.SN50v3_LB_Wind
        PhysicalSensorModelOption.WSC1L
        PhysicalSensorModelOption.DDS20_LB
        PhysicalSensorModelOption.DDS20_LS
        PhysicalSensorModelOption.RS485_LB_ZFS_02
        PhysicalSensorModelOption.RS485_LS_ZFS_02
        PhysicalSensorModelOption.PS_LB
        PhysicalSensorModelOption.PS_LS
        PhysicalSensorModelOption.SPH01_LB
        PhysicalSensorModelOption.SPH01_LS
        PhysicalSensorModelOption.LDDS75
        PhysicalSensorModelOption.DDS75_LB
        PhysicalSensorModelOption.DDS75_LS
        PhysicalSensorModelOption.WQS_LB
        PhysicalSensorModelOption.WQS_LS
    ]

    let options =
        modelList |> List.sortBy sensorModelOptionToString |> List.map modelToOption

    Select.select [ Select.IsFullWidth ] [
        select
            [
                DefaultValue(
                    List.tryFind (fun sensorType -> sensorType = selected) modelList
                    |> Option.defaultValue PhysicalSensorModelOption.LHT65
                    |> sensorModelOptionToString
                )
                OnChange(fun event ->
                    (optionFromString event.Value |> Option.get)
                    |> PhysicalSensorFormMsg.SelectedSensorModelChanged
                    |> dispatch
                )
            ]
            options
    ]

let private createFormField label id control =
    Field.div [] [
        Label.label [ Label.For id ] [ str label ]
        control
    ]

let private createSensorTypeField dispatch sensorType =
    let control =
        Control.div [ Control.IsExpanded ] [ sensorModelSelect sensorType dispatch ]

    createFormField "Sensor-Modell" "sensor_model" control

let private createNameField dispatch name =
    let id = "name"

    let control =
        Control.div [ Control.IsExpanded ] [
            Input.text [
                Input.Placeholder "MS-TLxxx"
                Input.Value(Option.defaultValue "" name)
                Input.OnChange(fun event ->
                    event.Value |> String.toOption |> PhysicalSensorFormMsg.NameChanged |> dispatch
                )
            ]
        ]

    createFormField "Eindeutiger Name des Sensors" id control

let private createAppEuiField dispatch appEui =
    let id = "app_eui"

    let control =
        Control.div [ Control.IsExpanded ] [
            Input.text [
                Input.Value(Option.defaultValue "" appEui)
                Input.OnChange(fun event ->
                    event.Value
                    |> String.toOption
                    |> PhysicalSensorFormMsg.AppEuiChanged
                    |> dispatch
                )
            ]
        ]

    createFormField "App EUI" id control

let private createDeviceEuiField dispatch editExisting deviceEui =
    let id = "device_eui"

    let control =
        Control.div [ Control.IsExpanded ] [
            Input.text [
                Input.Disabled editExisting
                Input.Value(Option.defaultValue "" deviceEui)
                Input.OnChange(fun event ->
                    event.Value
                    |> String.toOption
                    |> PhysicalSensorFormMsg.DeviceEuiChanged
                    |> dispatch
                )
            ]
        ]

    createFormField "Device EUI" id control

let private createAppKeyField dispatch appKey =
    let id = "app_key"

    let control =
        Control.div [ Control.IsExpanded ] [
            Input.text [
                Input.Value(Option.defaultValue "" appKey)
                Input.OnChange(fun event ->
                    event.Value
                    |> String.toOption
                    |> PhysicalSensorFormMsg.AppKeyChanged
                    |> dispatch
                )
            ]
        ]

    createFormField "App Key" id control

let private createNoteField dispatch description =
    let id = "note"

    let control =
        Control.div [ Control.IsExpanded ] [
            Textarea.textarea [
                Textarea.DefaultValue(Option.defaultValue "" description)
                Textarea.Placeholder "Interne Notizen zu dem Sensor"
                Textarea.Props [
                    SpellCheck false
                    AutoComplete "off"
                    AutoCorrect "off"

                    InputHelper.onBlurOptionalString (PhysicalSensorFormMsg.NoteChanged >> dispatch)
                ]
            ] []
        ]

    createFormField "Interne Notizen" id control

let private createDescriptionField dispatch description =
    let id = "description"

    let control =
        Control.div [ Control.IsExpanded ] [
            Textarea.textarea [
                Textarea.DefaultValue(Option.defaultValue "" description)
                Textarea.Placeholder "Beschreibung des Sensors"
                Textarea.Disabled true
                Textarea.Props [
                    SpellCheck false
                    AutoComplete "off"
                    AutoCorrect "off"

                    InputHelper.onBlurOptionalString (PhysicalSensorFormMsg.DescriptionChanged >> dispatch)
                ]
            ] []
        ]

    createFormField "TTS Beschreibung" id control

let private createOwnerField dispatch (users: UserDto list) (selectedUser: UserDto option) =
    let id = "owner"

    let control =
        Control.div [ Control.IsExpanded ] [
            UserSelect.view (PhysicalSensorFormMsg.SelectedOwnerChanged >> dispatch) selectedUser users
        ]

    createFormField "Besitzer" id control

let private createMaxHumidityField dispatch currentValue =
    let id = "max_humidity"

    let control =
        Control.div [ Control.IsExpanded ] [
            Input.text [
                Input.DefaultValue(currentValue |> Option.map string |> Option.defaultValue "")
                Input.OnChange(fun event ->
                    event.Value
                    |> Inputs.toDoubleOption
                    |> PhysicalSensorFormMsg.MaxHumidityChanged
                    |> dispatch
                )
            ]

            Help.help [] [
                str "Von diesem Wert aus werden alle neuen Luftfeuchtigkeiten auf 100% korrigiert"
            ]
        ]

    createFormField "Maximale Luftfeuchtigkeit [%]" id control

let private createPressureProbeField dispatch selectedProbe =
    let id = "pressure_probe"

    let control =
        Control.div [ Control.IsExpanded ] [
            PressureProbeSelect.view (PhysicalSensorFormMsg.PressureProbeChanged >> dispatch) selectedProbe
        ]

    createFormField "Druckmesser" id control

let private createPressureProbeMetersField dispatch (meters: int option) =
    let id = "pressure_probe_meters"

    let control =
        Control.div [ Control.IsExpanded ] [
            Input.text [
                Input.DefaultValue(meters |> Option.map string |> Option.defaultValue "")
                Input.OnChange(fun event ->
                    event.Value
                    |> Inputs.toIntOption
                    |> PhysicalSensorFormMsg.LiquidProbeDepthChanged
                    |> dispatch
                )
            ]
        ]

    createFormField "Maximale Wassertiefe [in m]" id control

let private createConditionField dispatch condition =
    let control =
        Control.div [ Control.IsExpanded ] [
            DeviceConditionSelect.view (PhysicalSensorFormMsg.ConditionChanged >> dispatch) condition
        ]

    createFormField "Zustand" "condition" control

let private createLocationField dispatch locations selectedLocation =
    let control =
        Control.div [ Control.IsExpanded ] [
            DeviceLocationSelect.view locations (PhysicalSensorFormMsg.LocationChanged >> dispatch) selectedLocation
        ]

    createFormField "Standort" "device_location" control

let form dispatch (model: Model) =
    form [] [
        createDescriptionField dispatch model.TtsDescription

        createDeviceEuiField dispatch model.EditExisting model.DeviceEui
        if not model.EditExisting then
            createAppEuiField dispatch model.AppEui
            createAppKeyField dispatch model.AppKey
        else
            ()

        createNameField dispatch model.Name
        createOwnerField dispatch model.AvailableUsers model.SelectedUser
        createConditionField dispatch model.DeviceCondition
        createLocationField dispatch model.AvailableLocations model.SelectedLocation

        createSensorTypeField dispatch model.SelectedModel

        match model.SelectedModel with
        | PhysicalSensorModelOption.LHT65
        | PhysicalSensorModelOption.LSN50v2_S31
        | PhysicalSensorModelOption.S31_LS
        | PhysicalSensorModelOption.S31_LB -> createMaxHumidityField dispatch model.MaxHumidity
        | PhysicalSensorModelOption.PS_LB
        | PhysicalSensorModelOption.PS_LS ->
            createPressureProbeField dispatch model.SelectedPressureProbe

            match model.SelectedPressureProbe with
            | PressureProbeOption.WaterDepth -> createPressureProbeMetersField dispatch model.LiquidProbeDepth
            | PressureProbeOption.Pressure -> ()
        | _ -> ()

        createNoteField dispatch model.Note
    ]

let buttonOptions (model: Model) dispatch =
    let maybeSensor = tryCreateSensor model

    let dynamicButtonOptions =
        match maybeSensor with
        | Some sensor ->
            let onClick =
                if model.EditExisting then
                    PhysicalSensorListMsg.UpdateSensor
                else
                    PhysicalSensorListMsg.CreateSensor

            [
                Button.Disabled false
                Button.OnClick(fun _ -> dispatch (onClick sensor))
            ]
        | None -> [ Button.Disabled true ]

    List.append
        [
            Button.IsLoading model.RequestRunning
            Button.Color IsSuccess
        ]
        dynamicButtonOptions

let view dispatch (model: Model) =
    let closeModal = (fun _ -> dispatch PhysicalSensorListMsg.CloseModal)

    let headline =
        if model.EditExisting then
            "Bestehenden Sensor bearbeiten"
        else
            "Neuer physikalischer Sensor erstellen"

    Modal.modal [ Modal.IsActive true ] [
        Modal.background [] []
        Modal.Card.card [] [
            Modal.Card.head [] [
                Modal.Card.title [] [ str headline ]
                Delete.delete [ Delete.OnClick closeModal ] []
            ]
            Modal.Card.body [] [
                Content.content [] [
                    form (PhysicalSensorListMsg.Form >> dispatch) model
                ]
            ]
            Modal.Card.foot [] [
                Button.button (buttonOptions model dispatch) [ str "Speichern" ]
            ]
        ]
    ]